export default __webpack_public_path__ + "static/media/portfolio-59.36bbaa97.jpg";